/* Click-to-play for the shared video block.
 *
 * The block renders a poster image plus a real link. This upgrades that link
 * into a facade: clicking swaps the poster for the provider's iframe, so a
 * recipe page never loads YouTube or Vimeo unless someone actually wants the
 * video. Without this file the link still works — it opens the video in a new
 * tab, which is what it did before the embed existed.
 *
 * The embed URL is built in Liquid (see snippets/hub-video.liquid) and passed on
 * data-hub-video, so provider parsing lives in exactly one place.
 */
(function () {
  'use strict';

  function play(frame, src, title) {
    var f = document.createElement('iframe');
    f.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
    f.title = title || 'Video';
    f.setAttribute('allowfullscreen', '');
    f.setAttribute('allow', 'autoplay; accelerometer; clipboard-write; encrypted-media; picture-in-picture');
    f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    frame.textContent = '';
    frame.appendChild(f);
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('.hub-video__play');
    if (!link) return;
    var frame = link.closest('[data-hub-video]');
    if (!frame) return;                       // no embed URL: let the link open
    var src = frame.getAttribute('data-hub-video');
    if (!src) return;
    e.preventDefault();
    play(frame, src, document.title);
  });
})();
